export const karolinaKasprzak = {
    'meta': {
        'title': 'Psychoterapeuta osób dorosłych Karolina Kasprzak • COLLIGO',
        'description': 'Jestem w trakcie czteroletniego szkolenia psychoterapeutycznego w Wielkopolskiej Szkole Psychoterapii Gestalt w Poznaniu.'
    },
    'url': {
        'address': '/bydgoszcz/zespol/psycholog-psychoterapeuta-karolina-kasprzak/'
    },
    'opengraph': {
        'image': {
            'url': '/images/team/open-graph/karolina-kasprzak.webp',
            'width': 150,
            'height': 150,
            'alt': 'Psycholog w Bydgoszczy, Psychoterapeuta w Bydgoszczy Karolina Kasprzak'
        }
    }
}